import {ChangeDetectorRef, Component, inject, model, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import * as uuid from 'uuid';
import {LabelOptions} from '@core/classes/options/label-options';
import {InputTypes} from '@core/enums';
import {FormControl, FormGroup} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {TranslateService} from '@ngx-translate/core';
import {InputOptions} from '@shared/components';

export class BreadcrumbOptions {
  id?: string = uuid.v4();
  show?: boolean;

  constructor(args?: BreadcrumbOptions) {
    this.id = args?.id || uuid.v4();
    this.show = args?.show !== undefined ? args?.show : true;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-breadcrumb',
  imports: [],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent implements OnInit {
  protected readonly router = inject(Router);
  private cdref = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  protected translations = this.translate.instant('breadcrumb');

  protected paths = model<string[]>([]);

  options = model<BreadcrumbOptions>(new BreadcrumbOptions({}));

  ngOnInit(): void {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('breadcrumb');
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(this.router.url.length === 1 && this.router.url[0] === '/') {
          this.paths.set([]);
        } else if(this.router.url.length > 1) {
          this.paths.set([
            ...['home'],
            ...this.router.url.substring(1, this.router.url.length).split('/')
          ])
        }
        console.log(this.router.url);
        console.log(this.paths());
        this.cdref.detectChanges();
      }
    });
  }

  goToCrumb(paths: string[], index: number) {
    console.log(paths.slice(0, index + 1));
    this.router.navigate(paths.slice(0, index + 1));
  }

  protected readonly Boolean = Boolean;
}
